import { useState } from "react";
import Overview from "./Overview";
import CatalogPage from "./CatalogePage";

export default function HomePage() {
  const [activeTab, setActiveTab] = useState("catalogPage");

  return (
    <div>
      {/* Page Title */}
      <h2 className="fw-semibold mb-4">Home</h2>

      {/* Sub-navigation (Overview tab) */}
      <div className="border-bottom mb-4">
        <button
          className={`btn btn-link text-decoration-none px-0 me-4 ${
            activeTab === "catalogPage"
              ? "text-primary fw-semibold"
              : "text-dark"
          }`}
          onClick={() => setActiveTab("catalogPage")}
        >
          Catalog
        </button>
      </div>
      {activeTab === "catalogPage" && <CatalogPage />}

      {/* Content */}
      {/* {activeTab === "overview" && <Overview />} */}
    </div>
  );
}
